/**
 * Platform fee calculation — additive model (percentage + fixed component).
 *
 * Frontend mirror of api/_utils/platform-fee.js. Must stay bit-identical with
 * the backend so client-side previews match the server's application_fee_amount
 * to the cent. When the shared npm package lands (@clickandshare/stripe-connect-
 * utils extraction ticket), both copies collapse into one import.
 *
 * Units:
 *   - totalCents: smallest currency unit (cents for EUR/USD, integer units for
 *     zero-decimal currencies).
 *   - pct: whole-number percentage as stored in the DB (2 = 2%).
 *   - fixedCents: smallest currency unit.
 */

/**
 * @param {number} totalCents
 * @param {number|null|undefined} pct
 * @param {number|null|undefined} fixedCents
 * @returns {number} application fee in the smallest currency unit
 */
export function calculateApplicationFee(totalCents, pct, fixedCents) {
  const pctPart = Math.round((Number(totalCents) || 0) * (Number(pct) || 0) / 100);
  const fixedPart = Number(fixedCents) || 0;
  return Math.max(0, pctPart + fixedPart);
}
